var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from 'graphql-tag';
export var addCreateLeadMutation = function () { return ({
    mutation: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation addUserAnalytics($input: REST!) {\n      addedUserAnalytics(input: $input)\n        @rest(type: \"createLead\", path: \"/zendesk\", method: \"POST\", endpoint: \"command\") {\n        id\n      }\n    }\n  "], ["\n    mutation addUserAnalytics($input: REST!) {\n      addedUserAnalytics(input: $input)\n        @rest(type: \"createLead\", path: \"/zendesk\", method: \"POST\", endpoint: \"command\") {\n        id\n      }\n    }\n  "]))),
}); };
export var addCreateLeadVariables = function (input) { return ({
    variables: {
        input: input,
    },
}); };
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/gql/zendesk.ts
// module id = 467
// module chunks = 81